module.exports = __webpack_public_path__ + "static/media/payment_terminal_image.c61d29ac.png";